/**
 * Layout Tokens
 * 
 * Authoritative values for layout dimensions across breakpoints.
 * See docs/design/*.md for specifications.
 */

// =============================================================================
// BREAKPOINTS (Authoritative)
// =============================================================================

export const BREAKPOINTS = {
  /** Mobile: < 768px (phones) */
  mobile: 768,
  /** Tablet: 768px - 1024px (iPad, tablets) */
  tablet: 1024,
  /** Desktop: > 1024px (laptops, monitors) */
  desktop: 1024,
} as const;

// =============================================================================
// NAVIGATION DIMENSIONS
// =============================================================================

export const NAVIGATION = {
  /** Mobile bottom tab bar height (includes safe area) */
  mobileTabBarHeight: 83,
  /** Mobile tab bar content height (without safe area) */
  mobileTabBarContentHeight: 49,
  
  /** Tablet sidebar width (collapsed, portrait) */
  tabletSidebarCollapsed: 64,
  /** Tablet sidebar width (expanded, landscape) */
  tabletSidebarExpanded: 200,
  
  /** Desktop sidebar width (always expanded) */
  desktopSidebarWidth: 240,
} as const;

// =============================================================================
// CONTENT DIMENSIONS
// =============================================================================

export const CONTENT = {
  /** Maximum content width on desktop (prevents ultra-wide stretching) */
  maxWidth: 1200,
  
  /** Content padding horizontal */
  paddingMobile: 16,
  paddingTablet: 24,
  paddingDesktop: 32,
  
  /** Content padding vertical */
  paddingVerticalMobile: 16,
  paddingVerticalTablet: 20,
  paddingVerticalDesktop: 24,
} as const;

// =============================================================================
// MASTER-DETAIL LAYOUT
// =============================================================================

export const MASTER_DETAIL = {
  /** Master panel width (tablet/desktop) */
  masterPanelWidth: 280,
  /** Context panel width percentage (desktop) */
  contextPanelWidthPercent: 35,
} as const;

// =============================================================================
// TOUCH TARGETS
// =============================================================================

export const TOUCH_TARGETS = {
  /** Minimum touch target size */
  minimum: 44,
  /** Recommended for primary actions */
  recommended: 48,
  /** List row minimum height */
  listRowHeight: 56,
  /** Sidebar icon touch target */
  sidebarIcon: 48,
} as const;

// =============================================================================
// Z-INDEX LAYERS
// =============================================================================

export const Z_INDEX = {
  /** Base content */
  content: 0,
  /** Sticky headers */
  stickyHeader: 10,
  /** Navigation (sidebar, tabs) */
  navigation: 100,
  /** Modals and overlays */
  modal: 1000,
  /** Toasts and notifications */
  toast: 1100,
} as const;

// =============================================================================
// ANIMATION DURATIONS
// =============================================================================

export const ANIMATION = {
  /** Fast interactions (button press) */
  fast: 150,
  /** Standard transitions */
  standard: 250,
  /** Navigation transitions */
  navigation: 300,
  /** Modal open/close */
  modal: 300,
} as const;

